import React, { useState, useEffect } from "react";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Badge from '@mui/material/Badge';
import Container from "react-bootstrap/Container";
import tagLogo from "../../assets/images/tag-logo.png";
import Image from "react-bootstrap/Image";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./SideBar.scss"
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';

function Sidebar() {
  const navigate = useNavigate();
  const token = localStorage.getItem("_token");
  const path = window?.location?.pathname?.split('/')?.[1]
  const [issueCount, setIssueCount] = useState(0);
  const [isseupendingCount, setIssuePendingCount] = useState(0);
  const [isseuresolvedCount, setIssueResolvedCount] = useState(0);
  const [isseurejectCount, setIssueRejectCount] = useState(0);

  const userData = JSON.parse(localStorage.getItem('userData'));
  const role = userData?.[0]?.role

  const [open, setOpen] = React.useState(true);
  const [tabText, settabText] = useState(path)

  useEffect(() => {
    if (role === "Admin") {
      getIssuesCount();
      window.addEventListener('storage', (e) => getIssuesCount());
      return () => {
        window.removeEventListener('storage', (e) => getIssuesCount());
      };
    }
  }, [])

  const getIssuesCount = async (id) => {
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Issue/Count_Issues`,
        {
          headers: headers,
        }
      );
      if (response.status === 400) {
        console.log("res:--", response)
        navigate("/login");
      }
      setIssueCount(response?.data?.data?.acceptList);
      setIssuePendingCount(response?.data?.data?.pendingList);
      setIssueResolvedCount(response?.data?.data?.resolvedList);
      setIssueRejectCount(response?.data?.data?.rejectList);

    } catch (error) {
      console.log(error);
    }
  };

  const handleClick = () => {
    setOpen(!open);
  };

  const getSelectedClassName = (tabName, isAppliances) => {
    return (tabText === tabName) || isAppliances ? "selected" : ""
  }

  return (
    <>
      {token ?
        <div className="menu-wrapper">
          <div className="menu-content">
            <Navbar bg="light" expand={"md"} className="mb-3 c-sidebar mt-0 pt-0">
              <Container fluid className="d-md-block p-0">
                <div className="top-brand d-md-flex d-none">
                  <Navbar.Brand href="#">
                    <Image src={tagLogo} alt={"Tag Logo Image"} fluid />
                  </Navbar.Brand>
                </div>
                <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${"md"}`} />
                <Navbar.Offcanvas
                  id={`offcanvasNavbar-expand-${"md"}`}
                  aria-labelledby={`offcanvasNavbarLabel-expand-${"md"}`}
                  placement="start"
                  className="sidebar-offcanvas"
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${"md"}`}>
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    {role === "Admin" ? (<div>
                      <List
                        sx={{
                          width: "100%",
                          maxWidth: 360,
                          bgcolor: "background.paper",
                        }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        subheader={
                          <ListSubheader
                            component="div"
                            id="nested-list-subheader"
                            className="menu-title text-uppercase"
                          >
                          </ListSubheader>
                        }
                      >

                        <ListItemButton onClick={handleClick}>
                          <ListItemIcon>
                            <ErrorOutlineOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Issues" />
                          {open ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                          <List component="div" disablePadding>
                            <ListItemButton sx={{ pl: 4 }} className={getSelectedClassName("issue")} onClick={() => { navigate('/issue'); settabText("issue") }}>
                              <ListItemIcon>
                                <PendingOutlinedIcon color="warning" />
                              </ListItemIcon>
                              <ListItemText primary="Pending" />
                              <Badge badgeContent={isseupendingCount} color="warning"></Badge>
                            </ListItemButton>
                          </List>
                          <List component="div" disablePadding>
                            <ListItemButton sx={{ pl: 4 }} className={getSelectedClassName("issueaccept")} onClick={() => { navigate('/issueaccept'); settabText("issueaccept") }}>
                              <ListItemIcon>
                                <VerifiedOutlinedIcon color="info" />
                              </ListItemIcon>
                              <ListItemText primary="Accept" />
                              <Badge badgeContent={issueCount} color="warning"></Badge>
                            </ListItemButton>
                          </List>
                          <List component="div" disablePadding>
                            <ListItemButton sx={{ pl: 4 }} className={getSelectedClassName("issueresolve")} onClick={() => { navigate('/issueresolve'); settabText("issueresolve") }}>
                              <ListItemIcon>
                                <TaskAltOutlinedIcon color="success" />
                              </ListItemIcon>
                              <ListItemText primary="Resolved" />
                              <Badge badgeContent={isseuresolvedCount} color="warning"></Badge>
                            </ListItemButton>
                          </List>
                          <List component="div" disablePadding>
                            <ListItemButton sx={{ pl: 4 }} className={getSelectedClassName("issuerejected")} onClick={() => { navigate('/issuerejected'); settabText("issuerejected") }}>
                              <ListItemIcon>
                                <CancelOutlinedIcon color="error" />
                              </ListItemIcon>
                              <ListItemText primary="Rejected" />
                              <Badge badgeContent={isseurejectCount} color="warning"></Badge>
                            </ListItemButton>
                          </List>

                        </Collapse>
                        <ListItemButton className={getSelectedClassName("management")} onClick={() => { navigate('/management'); settabText("management") }}>
                          <ListItemIcon className={getSelectedClassName("management")}>
                            <ListOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Management" />
                        </ListItemButton>
                        <ListItemButton className={getSelectedClassName("appliances", tabText.includes('appliances'))} onClick={() => { navigate('/appliances'); settabText("appliances") }}>
                          <ListItemIcon className={getSelectedClassName("appliances", tabText.includes('appliances'))}>
                            <ComputerOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Appliances" />
                        </ListItemButton>
                        <ListItemButton className={getSelectedClassName("vendors")} onClick={() => { navigate('/vendors'); settabText("vendors") }}>
                          <ListItemIcon className={getSelectedClassName("vendors")}>
                            <PermIdentityOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Vendors" />
                        </ListItemButton>
                        <ListItemButton className={getSelectedClassName("brands")} onClick={() => { navigate('/brands'); settabText("brands") }}>
                          <ListItemIcon className={getSelectedClassName("brands")}>
                            <CategoryRoundedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Brands" />
                        </ListItemButton>
                      </List>
                    </div>) : <div>
                      <List
                        sx={{
                          width: "100%",
                          maxWidth: 360,
                          bgcolor: "background.paper",
                        }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        subheader={
                          <ListSubheader
                            component="div"
                            id="nested-list-subheader"
                            className="menu-title text-uppercase"
                          >
                          </ListSubheader>
                        }
                      >
                        <ListItemButton className={getSelectedClassName("user")} onClick={() => { navigate('/user'); settabText("user") }}>
                          <ListItemIcon className={getSelectedClassName("user")}>
                            <ErrorOutlineOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Issues" />
                        </ListItemButton>
                      </List>
                    </div>}
                  </Offcanvas.Body>
                </Navbar.Offcanvas>
              </Container>
            </Navbar>
          </div>
        </div>
        : null}
    </>
  );
}

export default Sidebar;
